<style scoped lang="scss">
  .wrap-primer{
    .top{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .title{
      h3{
        font-size: 24px;
        font-weight: bold;
      }
    }
    .el-steps{
      width:350px;
    }
    .address{
      background: #F9F9F9;
      padding:15px 20px;
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }
    .product{
      border: 1px solid #E4E6EA;
      .title{
        display: flex;
        justify-content: space-between;
        padding:10px 30px;
        border-bottom: 1px solid #E4E6EA;
      }
      .con{
        padding:20px 30px;
        display: flex;
        align-items: center;
        img{
          margin-right: 20px;
          width:106px;
        }
      }
    }
  }
  .total{
    background: #F0F0F0;
    text-align: right;
    span{
      margin-right:30px;
      display: inline-flex;
      align-items: center;
    }
    .el-button{
      font-size: 20px;
      padding:14px 20px;
    }
  }
  .relief{
    max-height: 500px;
    overflow-y: auto;
    h4{
      margin-top: 10px;
    }
    p{
      margin-top: 10px;
    }
  }
</style>
<template>
  <div class="wrap wrap-primer">
    <section class="container">
      <div class="top">
        <div class="title">
          <h3>积分兑换订单确认</h3>
        </div>
      </div>
      <qk-edit-address/>
      <div class="product mt20">
        <div class="title">
          <div class="fb">产品信息</div>
          <p>进行积分兑换前请详细阅读：
            <span class="text-primary pointer" @click="rulesVisible = true">《擎科生物积分礼品兑换细则》</span>
            <span class="text-primary pointer" @click="reliefVisible = true">《免责声明》</span>
          </p>
        </div>
        <div class="con">
          <img :src="details.mainImgUrl">
          <div class="info">
            <p class="fz16">{{details.name}}</p>
            <p class="text-gray9 mt10" v-html="details.detail"></p>
          </div>
        </div>
      </div>
      <div class="total mt30">
        <span>商品总数：<span class="text-primary fz20 fb">1</span></span>
        <span>消耗积分：<span class="text-primary fz20 fb">{{details.price}}</span></span>
        <span>剩余积分：<span class="text-primary fz20 fb">{{points.availablePoints}}</span></span>
        <el-button type="primary" @click="onsubmit">确认下单</el-button>
      </div>
    </section>
    <!--免责申明弹出框-->
    <el-dialog
      title="免责声明"
      :visible.sync="reliefVisible"
      width="50%">
      <div class="relief">
        <p class="text-danger">1、擎科生物积分商城规则依据国家相关法律法规及规章制度予以解释和修改，积分及兑换规则以
          擎科生物的公布为准。</p>
        <p>2、申请兑换礼品的客户请仔细阅读本须知及相关申请流程，凡进行积分兑换者视为不可撤销认可
          本须知及相关申请流程的规定；</p>
        <p class="text-danger">3、擎科生物积分商城所兑换的礼品属于客户，即申请人所在单位；申请人须确认所在单位或负责
          人已知晓此活动详情和礼品去向，有权操作客户账户视为申请人有权代表客户兑换礼品；申请
          人领取奖励礼品后视为申请人所属单位已收到该奖励礼品，擎科生物不承担礼品发放后的其他
          责任。</p>
        <p class="text-danger">4、礼品兑换申请人需为订单提交者本人，如非本人申请，请出示由申请人书面签字授权的授权
          书。</p>
        <p>5、如发现所兑换商品存在质量及数量问题，申请人需在礼品收到后5个工作日内同擎科生物或当
          地销售联系。如逾期，则视为已确认无误。</p>
        <p>6、擎科生物积分商城所展示礼品均最终以实物为准。</p>
        <p>7、根据市场变化，擎科生物保留更换礼品清单或相应积分分值的权利。可供换领、换购的礼品种
          类以申请当日擎科生物积分换领网站公布内容为准。所有兑换礼品数量有限，限量类礼品先到
          先得。若申请的限量类礼品已换完，则我公司可在同档礼品中调剂兑换，并可不事先通知换礼
          申请人。</p>
        <p>8、积分有效期为两年，以积分获得之日起开始计算，凡未在积分有效期内按照上述要求申请兑换
          礼品，逾期者视为放弃该等权利，擎科生物将不予补发；未在有效期内兑换礼品的客户，擎科
          生物不承担任何责任，请客户及时兑换。</p>
        <p>9、擎科生物有权根据活动需要取消本计划或增删、修订本规定。所有活动规定以擎科生物积分网
          站最新公布内容为准。</p>
        <p>10、擎科生物将在法律许可的范围内保留本次活动的最终解释权。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reliefVisible = false">取消</el-button>
        <el-button type="primary" @click="reliefVisible = false">确定</el-button>
      </span>
    </el-dialog>
    <!--积分礼品兑换细则弹出框-->
    <el-dialog
      title="擎科生物积分礼品兑换细则"
      :visible.sync="rulesVisible"
      width="50%">
      <div class="relief">
        <p>擎科生物关于积分系统变换的说明：擎科生物原积分商城包含“积分”及“金币”两重体系，即“积
          分”只与等级有关，“金币”可以在积分商城兑换礼品。从2020年9月1日起，擎科生物将对积分商
          城的的体系进行改变，取消原有积分等级制度，取消原有金币制度，将原有的积金币规则，转换
          为积分规则，累计规则不变，原有金币名称转变为积分。</p>
        <p>例如：5金币=5积分</p>
        <h4>一、积分兑礼品基本原则：</h4>
        <p>1. 本活动仅适用于擎科生物所有客户。<br>
          2. 终端客户订购服务(产品)，符合条件则可获得擎科生物积分并享受积分兑换礼品优惠活动。
        </p>
        <h4>二、积分获得及兑换：</h4>
        <p>1. 客户下单是获取积分的主要手段；此外，擎科生物会不定期推出一些活动，参加这些活动也可
          以赢取积分（及其他奖励）。<br>
          2. 客户下订单后，即可获得一定数量的待激活积分。待订单回款后，待激活积分会在3个工作日之
          内转化为可用积分，可在积分商城兑换礼品。<br>
          3. 订单汇款获取积分的数量由系统自动计算，其数值一般与订单付款金额呈正比关系。不同服务
          线的订单金额和相应积分的比例有所区别。<br>
          4. 对于已取消的订单，会扣除相应的待激活积分（客户已付款，且不要求退款的除外）。</p>
        <h4>三、积分有效期：</h4>
        <p>1. 积分有效期为两年，以积分获得之日起开始计算，凡未在积分有效期内按照上述要求申请兑换
          礼品，逾期者视为放弃该等权利，擎科生物将不予补发；</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rulesVisible = false">取消</el-button>
        <el-button type="primary" @click="rulesVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pointsGoodsDetail, createPointsOrders, customerPoints } from '@/services/api.index'
export default {
  data () {
    return {
      id: this.$route.query.id,
      details: {},
      points: {},
      reliefVisible: false,
      rulesVisible: false
    }
  },
  created() {
    this.getDetails()
    this.getPoints()
  },
  methods: {
    getDetails () {
      pointsGoodsDetail(this.id).then(res => {
        this.details = res.data
      })
    },
    // 获取积分
    getPoints () {
      customerPoints().then(res => {
        this.points = res.data
      })
    },
    // 确认下单
    onsubmit () {
      let address = this.baseMethods.getAddress()
      createPointsOrders(this.id, address).then(() => {
        this.$message.success('提交成功！')
        this.$router.push('/tec/success_submit?type=integral')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/order_intergal.vue